import React from "react";
import PropTypes from "prop-types";
import { ReactComponentStaticProps } from "../../types/react";
import { GroupProvider } from "./GroupContext";

export type ComparisonTableGroupProps = {
  children: React.ReactNode;
};

export const ComparisonTableGroup: ((
  props: ComparisonTableGroupProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableGroupProps> = ({ children }) => {
  return <GroupProvider>{children}</GroupProvider>;
};

ComparisonTableGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

ComparisonTableGroup.displayName = "ComparisonTable.Group";

export default ComparisonTableGroup;
